/** フィルタ用の擬似 planID（CHILLNN 部屋料金ランク行） */
export const CHILLNN_ROOM_RANK_PLAN_ID = "__chillnn_room_rank__";

/** 行見出し（プランなし予約が可能なときの確認用行） */
export const CHILLNN_ROOM_RANK_PLAN_NAME = "プランなし";

/** フィルタ用の擬似 planID（DailyRate.planID なしの部屋料金行） */
export const ROOM_RATE_PLAN_ID = "__room_rate__";

/** 行見出し（連携先から取り込んだ部屋の日別料金。プランを付けない） */
export const ROOM_RATE_PLAN_NAME = "プランなし";
